export const MAX_SELECTED_ORDERS = 50;

export function canSelectOrder(order) {
  return Boolean(order?.id && order.status !== "archiviert");
}

// Preserve selections outside the loaded filter, but use the latest visible revision.
export function reconcileSelection(selected, orders) {
  const next = { ...selected };
  for (const order of orders) {
    if (!next[order.id]) continue;
    if (canSelectOrder(order)) next[order.id] = order;
    else delete next[order.id];
  }
  return next;
}

export function toggleSelection(selected, order) {
  const next = { ...selected };
  if (next[order.id]) delete next[order.id];
  else if (canSelectOrder(order) && Object.keys(next).length < MAX_SELECTED_ORDERS) next[order.id] = order;
  return next;
}

export function orderNextAction(order) {
  const base = `/admin/website-production/${encodeURIComponent(order.id)}`;
  if (order.status === "archiviert") return { to: base, label: "Auftragsdetails" };
  if (order.status === "vollstaendig") return { to: `${base}/package`, label: "Kundenpaket prüfen" };
  return { to: `${base}/edit`, label: "Auftragsdaten ergänzen" };
}

export function sortOrders(orders, sort) {
  const updated = order => Date.parse(order.updated_at) || 0;
  const company = (a, b) => String(a.company || "").localeCompare(String(b.company || ""), "de-CH");
  return [...orders].sort((a, b) => {
    if (sort === "company") return company(a, b);
    if (sort === "missing") {
      const count = (b.missing?.length || 0) - (a.missing?.length || 0);
      if (count) return count;
    }
    return updated(b) - updated(a) || company(a, b);
  });
}
